import AddCalendarsPaneRenderer from './AddCalendarsPaneRenderer';
import FullComposeRenderer from './FullComposeRenderer';
import MobilityComposeRenderer from './MobilityComposeRenderer';
import ReadingPanePanel from './ReadingPanePanel';
import { observer } from 'mobx-react-lite';
import { store } from 'owa-calendar-module-command';
import { isBoardViewTypeSelected } from 'owa-calendar-module-store';
import { QuickComposeRenderer } from 'owa-calendar-quick-compose-view';
import { CalendarSharingPermissionsModalRenderer } from 'owa-calendar-sharing';
import { shouldCalloutCoverTargetGrid } from 'owa-calendar-surface-view';
import * as React from 'react';

/**
 * These are common renderers necessary for every view type
 */
const commonRenderers = {
    Open_ReadPanel: () => <ReadingPanePanel />,
    Open_QuickCompose: () => (
        <QuickComposeRenderer
            shouldCoverTarget={
                isBoardViewTypeSelected()
                    ? shouldQuickComposeCoverBoard
                    : shouldCalloutCoverTargetGrid
            }
        />
    ),
    Open_FullComposeForm: () => <FullComposeRenderer />,
    Open_SharingPermissionsDialog: () => <CalendarSharingPermissionsModalRenderer />,
    Open_AddCalendars: () => <AddCalendarsPaneRenderer />,
    Open_MobilityCompose: () => <MobilityComposeRenderer />,
};

/**
 * This component ensures that context menus, item peeks and quick compose popups are mutually exclusive
 * It fixes a race when new user request comes before previous one is completed.
 */
const ModuleRenderer = observer(function ModuleRenderer() {
    if (!store.moduleCommand || store.moduleCommand === null) {
        return null;
    }

    if (commonRenderers[store.moduleCommand]) {
        return commonRenderers[store.moduleCommand]();
    }
});

export default ModuleRenderer;

function shouldQuickComposeCoverBoard() {
    return false;
}
